import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Typography from "apollo-react/components/Typography";
import DataTableComponent from "../../../common/DataTable/PrimeDataTable";
import { getTableColumns } from "./tableConfig";
import "./styles.css";
import { CATEGORIES } from "../../../../constants/categories";

export default function MembersStatuses({ requestProgressId, requestProgress, children, requestId,
    data: initialData = [], onRowClick }) {
    const { t } = useTranslation();
    const [data, setData] = useState(initialData);

    useEffect(() => {
        const updatedData = initialData.map((item) => {
            const reviewerName =
            item.first_name && item.last_name
              ? `${item.first_name} ${item.last_name}`
              : item.username || `Member ${item.id}`;

            const categoryName = item?.end_users_category?.name || '';
            // const process = CATEGORIES.ECTD_ASSESSMENT_CATEGORIES.includes(categoryName)
            //   ? "eCTD"
            //   : categoryName === CATEGORIES.INSPECTION_DEPARTMENT
            //   ? "Inspection"
            //   : categoryName === CATEGORIES.CONTROL_LAB_VALIDATION
            //     ? "Lab"
            //     : "Other"
            const process = categoryName.split(' ')[1];


            const reviewValue = item?.review?.review || '-';
            const status = reviewValue === '-' ? reviewValue : reviewValue.charAt(0).toUpperCase() + reviewValue.slice(1);

            return {
                id: item.id,
                status,
                process,
                reviewer: reviewerName,
                categoryName,
                originalData: item,
            };
        });
        
        setData(updatedData);
    }, [initialData]);

    useEffect(() => {
        const rows = document.querySelectorAll('.members-status-table .p-datatable-tbody > tr');
        rows.forEach((row, index) => {
            if (data[index]) {
                const tooltipText = t('assessmentReviews.rowTooltip', { process: data[index].process });
                row.setAttribute('title', tooltipText);
            }
        });
    }, [data, t]);

    const columns = getTableColumns();

    const handleRowClick = (rowData) => {
        if (onRowClick) {
            onRowClick(rowData.data);
        }
    };

    return (
            <div style={{marginTop: '-40px'}} className="members-status-table">
                <Typography 
                    variant="caption" 
                    style={{ 
                        display: 'block', 
                        marginBottom: '12px',
                        color: '#6E6E6E',
                        fontStyle: 'italic'
                    }}
                >
                    {t('assessmentReviews.clickRowToNavigate')}
                </Typography>
                <DataTableComponent
                    data={data}
                    columns={columns}
                    enablePagination={false}
                    totalRecords={data.length}
                    onRowClick={handleRowClick}
                    rowClassName={(rowData) => 'clickable-row'}
                />
            </div>
    );
}
